<template>
    <div>
        <template v-for="( key, index ) in headers">
            <span
                class="table__body__row__text position--relative"
                :class="`table__${model}__col__${index}`"
                :key="index"
            >
                <template v-if="[ 'id' ].includes( key )" >
                    <input
                        type="checkbox"
                        :name="`entity-${row[key]}`"
                        :id="`entity-${row[key]}`"
                        v-model="ids"
                        :value="row[key]"
                        class="field__checkbox__input display--none"
                    />
                    <label :for="`entity-${row[key]}`"
                        class="field__checkbox entity__checkbox position--relative display--block pointer"
                    >
                        <span
                            :class="[
                                'field__checkbox__icon entity__icon display--inline-b position--absolute',
                                row[key] % 2 === 0 ? 'background--grey--light'  : 'background--white'
                            ]"
                            aria-hidden="true"
                            :aria-label="$t('accessibility.arrow')">
                        </span>
                        {{ row[key] }}
                    </label>
                </template>
                <template v-if="[ 'name' ].includes( key )" >
                    {{ row[key] }}
                </template>
                <template v-else-if="[ 'EAC' ].includes( key )" >
                    {{ row.economicActivityCodes[0].code }}
                </template>
                <template v-else-if="[ 'zone' ].includes( key )" >
                    {{ row.addresses[0].zipCode.district }}
                </template>
                <template v-else-if="[ 'zipCode' ].includes( key )" >
                    {{ row.addresses[0].zipCode.code }}-{{ row.addresses[0].zipCode.extension }}
                </template>
                <template v-else-if="key === 'contact'" >
                    {{ row.contactPerson }}
                </template>
            </span>
        </template>
    </div>
</template>

<script>
// package
import {
    reactive,
    toRefs,
    watch,
    computed
} from '@vue/composition-api';

// hooks
import tableStructure from '@/hooks/use-table';

// store
import { mapState, useStore } from '@/hooks/use-store';

export default {
    ...tableStructure,
    setup ( props ) {
        const entity = reactive({
            ids: []
        });
        const texts = {
            active: {
                translate: 'activeToken',
                button: 'active',
                color: 'green'
            },
            delete: {
                translate: 'deleteToken',
                button: 'delete',
                color: 'red'
            },
            disable: {
                translate: 'disableToken',
                button: 'disable',
                color: 'red'
            }
        };

        const state = reactive({
            translate: '',
            buttonText: '',
            type: '',
            success: '',
            color: 'red',
            show: {
                modal: false,
                tooltip: false
            }
        });

        const { getters, actions } = useStore();

        // registo dos campos necessários para a
        // submissão para a API.
        const registerData = () => {
            const fields = [
                { name: 'id', value: props.row.id },
                ...( state.type !== 'delete'
                    ? [
                        { name: 'method', value: 'put' },
                        { name: 'revoked', value: !props.row.revoked ? 1 : 0 }
                    ]
                    : [ { name: 'endpoint', value: '/clients/personal-access-token' } ]
                )
            ];

            fields.forEach( field => {
                actions( 'registerField', field );
            });
        };

        const clearData = () => {
            if ( !state.success )
                actions( 'resetPayload' );

            state.success = '';
        };

        const toggleModal = type => {
            state.show.modal = !state.show.modal;

            // definição das configurações que irão
            // aparecer na modal
            // -- Titulo & texto
            // -- texto do botão
            // -- cor da modal
            state.translate = texts[type]?.translate;
            state.buttonText = texts[type]?.button;
            state.color = texts[type]?.color;
            state.type = type;

            // bloqueia a barra de adição & edição.
            actions( 'controlActionBar', { value: state.show.modal });

            // se acção for abrir a modal:
            // -- irá registar na store os valores necessários
            //    para serem enviados para API.
            // se ação for fechar a modal:
            // -- irá limpar da store os valores anteriormente
            //    adicionados.
            state.show.modal
                ? registerData()
                : clearData();
        };

        // obtenção do trigger
        const trigger = mapState({ module: 'storePayload', key: 'trigger' });

        // Watch para validar se houve alguma alteração numa
        // determinada linha, caso haja, significa que é necessário
        // fechar o modal.
        watch( () => trigger.value,
            newTrigger => {
                if ( newTrigger && state.show.modal )
                    state.show.modal = false;
            });

        // obtenção do loading da submissão
        const loading = mapState({ module: 'storePayload', key: 'loading' });

        // validação se esta no modo de edição ou não.
        const isInEditMode = computed( () => getters.isInEditMode );

        // obtenção do payload & errors
        const store = reactive({
            helpers: mapState({ module: 'storePayload', key: 'helpers' })
        });

        // Watch para adicionar e retirar valores do payload quando uma entidade é selecionada
        let inexistentEntity = false;
        watch( () => entity.ids,
            ( newSelect, oldSelect ) => {
                store.helpers.selectedEntities.forEach( ( element, index ) => {
                    if ( oldSelect[0] === element ) {
                        store.helpers.selectedEntities.splice( index, 1 );
                        inexistentEntity = false;
                    } else
                        inexistentEntity = true;
                });

                if ( inexistentEntity || oldSelect.length === 0 )
                    store.helpers.selectedEntities.push( newSelect[0] );

                // gravar array de entidades selecionadas no helper do payload
                actions( 'saveHelper', { selectedEntities: store.helpers.selectedEntities });

                if ( store.helpers.selectedEntities.length )
                    actions( 'registerField', { name: 'entitiesIds', value: store.helpers.selectedEntities });
                else
                    actions( 'deleteField', { name: 'entitiesIds', payloadKey: 'payload' });
            });

        return {
            ...toRefs( state ),
            toggleModal,
            loading,
            isInEditMode,
            ...toRefs( entity )
        };
    }
};
</script>
<style lang="scss">
    .entity {
        &__checkbox {
            padding-left: 5px;
        }
        &__icon{
            @include transform-position( 4px, false, false, -25px );
        }
    }
</style>